import React from "react";
import {
  PopularFilled,
  PopularOutlined,
  GameFilled,
  GameOutlined,
  ProfileFilled,
  ProfileOutlined,
  PromotionOutline,
  PromotionFilled,
} from "@assets";
import { Container, ItemWrapper, Label } from "./BottomNavigator.style";
import { useLocation, useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { useTranslation } from "react-i18next";
import { localStorage } from "@utils";

const Item = ({ path, label, icon, icon_active, is_home, is_noti, index }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const is_active = pathname.includes(path);
  const userPreferedLanguage = localStorage.getUserPreferedLanguage();

  const handleClicked = (path, is_home) => {
    let _path = "";
    if (is_noti) {
      _path = is_home ? `/home/${path}` : `/${path}`;
    } else {
      _path = is_home ? path : `/${path}`;
    }
    navigate(_path, { replace: true });
  };

  return (
    <ItemWrapper
      // style={{
      // 	marginRight: index === 1 && "50px",
      // 	marginLeft: index === 2 && "50px",
      // }}
      index={index}
      onClick={() => handleClicked(path, is_home)}
    >
      {is_active ? icon_active : icon}
      <Label
        lang={userPreferedLanguage}
        status={is_active ? "active" : "default"}
      >
        {label}
      </Label>
    </ItemWrapper>
  );
};

const BottomNavigator = (isNoti) => {
  const { t } = useTranslation();
  const userPreferedLanguage = localStorage.getUserPreferedLanguage();

  const options = [
    {
      path: PUBLIC_ROUTE.POPULAR,
      label: t("bottomNavigator.popular"),
      icon: <PopularOutlined />,
      icon_active: <PopularFilled />,
      is_home: true,
    },
    {
      path: PUBLIC_ROUTE.GAMES,
      label: t("bottomNavigator.games"),
      icon: <GameOutlined />,
      icon_active: <GameFilled />,
      is_home: true,
    },
    {
      path: PUBLIC_ROUTE.NOTIFICATION,
      label: t("bottomNavigator.notification"),
      icon: <PromotionOutline />,
      icon_active: <PromotionFilled />,
      is_home: false,
    },
    {
      path: PUBLIC_ROUTE.PROFILE,
      label: t("bottomNavigator.profile"),
      icon: <ProfileOutlined />,
      icon_active: <ProfileFilled />,
      is_home: true,
    },
  ];

  return (
    <Container lang={userPreferedLanguage}>
      {options.map((item, key) => (
        <Item
          key={key}
          index={key}
          path={item.path}
          label={item.label}
          icon={item.icon}
          icon_active={item.icon_active}
          is_home={item.is_home}
          is_noti={isNoti}
        />
      ))}
    </Container>
  );
};

export default BottomNavigator;
